export const wagerSelectionMap={
    selection:0,
    homeFav:1,
    awayFav:2,
    eventDateFm: 3,
    oddString:4,
    scores:5,
    sportId:6,
    sportName:7,
    sportGroup:8,
    leagueName:9,
    homeTeam : 10,
    awayTeam: 11,
    betType:12,
    eventDate:13,
    wagerId: 14,
    selectionType:15,
    score:16,
    isInPlay:17,
    odds:18,
    handicap:19,
    homePitcher:20,
    awayPitcher:21,
    homePitcherName:22,
    awayPitcherName:23,
    period:24,
    result:25,
    legStatus:26,
    teamType:27,
    eventName:28,
    point:29,
    type:30,
    altTeaser:31,
    adjOdds:32,
    adjOddsStr: 33, 
    raceNumber: 34, 
    trackName: 35, 
    runnerNumber: 36, 
    runnerName: 37, 
    hrBetType: 38, 
    hrMarketType: 39,
    trackCountry: 40,
    deductions: 41,
    scratchedName: 42,
    gradingUnit: 44,
    eventId: 45,
    betAcceptanceType: 47
};
export const wagerMap = {
    pnl:0,
    commission:1,
    validBetAmount:2,
    ip_address:3,
    result:4,
    scores:5,
    status_result:6,
    wagerId:7,
    masterWagerId:8,
    eventName:9,
    parentEventName:10,
    headToHead:11,
    wagerNumber:12,
    wagerNo:13,
    wagerDateFm:14,
    eventDateFm:15,
    oddsString:16,
    eventDate:17,
    status:18,
    wagerDate:19,
    homeName:20,
    awayName:21,
    selection:22,
    selectionType:23,
    handicap:24,
    odds:25,
    oddsFormat:26,
    betType:27,
    league:28,
    stake:29,
    sportId:30,
    sportName:31,
    sportGroup:32,
    currencyCode:33,
    homeFav:34,
    awayFav:35,
    inPlayScore:36,
    inPlay:37,
    homePitcher:38,
    awayPitcher:39,
    homePitcherName:40,
    awayPitcherName:41,
    period:42,
    cancellationStatus:43,
    wagerSelections:44,
    category:45,
    unit:46,
    winRiskStake:47,
    toWin:48,
    toRisk:49,
    product:50,
    vsHandicap:51,
    vsSelection:52,
    vsBetType:53,
    vsMarketType:54,
    vsSelectionName:55,
    parlayMixOdds:56,
    vsLegStatus:57,
    vsSubType:58,
    multiplier:59,
    teamType:60,
    parlayMixOddsStr:61,
    competitors:62,
    vsWagerSelections:63,
    vsMixParlaySelections: 66,
    adjOdds:67,
    adjOddsStr: 68,
    betAcceptanceType: 69,
    settlementDate:70,
    settlementDateFm:71,
    wagerType:72,
    relateEventBetType:73,
    raceNumber: 74,
    trackName: 75,
    runnerNumber: 76,
    runnerName: 77,
    hrBetType: 78,
    hrMarketType: 79,    
    trackCountry: 80,
    deductions: 81,
    scratchedName: 82,
    gradingUnit:84,
    commonBetType: 85,
    originalHomeTeam: 91,
    resettleInfo: 92
};

export const vsWagerSelectionMap={
    handicap:0,
    selection:1,
    betType:2,
    vsHandicap:3,
    sportId:4,
    sport:5,
    competitors:6,
    homeFav:7,
    awayFav:8,
    homeTeam:9,
    awayTeam:10,
    vsMarketType:11,
    eventDateFm:12,
    odds:13,
    oddsFormat:14,
    oddsStr:15,
    eventName:16,
    vsLegStatus: 17,
    isMoneyLine: 18,
    vsSubType:19,

}
export const casisonWagerMap={
    casinoCode:0,
    wagerId:1,
    transactionDateFm:2,
    status:3,
    winLoss:4,
    stake:5,
    gameDesc:6,
    betPointsDisplay:7,
    betResultDisplay:8,
    commission:9,
    transactionDate: 10
}
export const ionWagerMap={
    casinoCode:0,
    wagerId:1,
    refNum:2,
    transactionDateFm:3,
    status:4,
    winLoss:5,
    stake:6,
    gameDesc:7,
    commission:8,
    groupBetOptionTranslate:9,
    selection: 10,
    transactionDate: 11
}
export const agWagerMap={
    casinoCode:0,
    wagerId:1,
    transactionDateFm:2,
    status:3,
    winLoss:4,
    stake:5,
    gameDesc:6,
    betPointsDisplay:7,
    betResultDisplay:8,
    commission:9,
    selection: 10,
    transactionDate: 11
}
export const aginWagerMap={
    casinoCode:0,
    wagerId:1,
    transactionDateFm:2,
    status:3,
    winLoss:4,
    stake:5,
    gameDesc:6,
    betPointsDisplay:7,
    betResultDisplay:8,
    commission:9,
    dateFitlerType: 10,
    selection: 11,
    transactionDate: 12,
    settlementDate: 13
}
export const playtechWagerMap={
    casinoCode:0,
    wagerId:1,
    transactionDateFm:2,
    status:3,
    winLoss:4,
    stake:5,
    gameDesc:6,
    bet:7,
    win:8,
    commission:9,
    transactionDate: 10
}
export const iforiumWagerMap={
    casinoCode:0,
    wagerId:1,
    gameTitle:2,
    transactionDate:3,
    settlementDate: 4,
    stake:5,
    winLoss:6,
    commission:7,
    status:8,
    providerName:9,
    gameId:10,
    transactionDateTime:11,
    settlementDateTime: 12,
}
export const dgWagerMap = {
    productCode: 0,
    wagerId: 1,
    gameTitle: 2,
    transactionDate: 11,
    settlementDate: 12,
    stake: 5,
    winLoss: 6,
    commission: 7,
    status: 8,
    gameID: 9,
    deviceType: 10,
    gameType: 11
}
export const PAGE_TYPE = {
    PENDING : 'PENDING',
    GRADED : 'GRADED',
}

export const eventScoreMap = {
    period:0,
    score:1,
}


export const MY_BETS = {
    data : '[[0E-7,0E-9,0,"125.234.113.78",null,null,null,36896068,0,"Weston Workers Bears Fc-vs-Valentine Phoenix",null,null,1,null,"2019-05-22 06:12:18","2019-05-22","1.746",1558515600000,"OPEN",1558519938000,"Weston Workers Bears Fc","Valentine Phoenix","Under",4,1.75,1.746,1,3,"Australia - FFA Cup Qualifiers",1.00,29,"Soccer",0,"CNY",0,0,"0-0",1,null,null,null,null,0,null,null,null,"","RISK",0.7500000,1.0000000,"SB","","",0,"","",1.7460000,null,"",0,0,null,0,0,0,null,null],[0E-7,0E-9,0,"125.234.113.78",null,null,null,36896056,0,"Eunhye Lee-vs-Alicia Barnett",null,null,1,null,"2019-05-22 06:00:47","2019-05-22","1.892",1558508340000,"OPEN",1558519247000,"Eunhye Lee","Alicia Barnett","Eunhye Lee",0,-1.50,1.892,1,2,"ITF Women Goyang - R1",1.00,33,"Tennis",2,"CNY",1,0,"",1,null,null,null,null,0,null,null,null,"","RISK",0.8900000,1.0000000,"SB","","",0,"","",1.8920000,null,"",0,0,null,0,0,0,null,null],[0E-7,0E-9,0,"125.234.113.78",null,null,null,36876408,0,"Women World Cup Winner 2019",null,null,1,null,"2019-05-15 23:05:38","2019-06-07","76.000",1559934000000,"OPEN",1557975938000,"Argentina (w)","Women World Cup Winner 2019","",null,0.00,76.000,1,99,"FIFA - World Cup Women",1.00,29,"Soccer",0,"CNY",0,0,"",0,null,null,null,null,0,null,null,"Futures","","RISK",75.0000000,1.0000000,"SB","","",0,"","",76.0000000,null,"",0,0,null,0,0,0,null,null]]'
};


// WEBPACK FOOTER //
// ./src/app/components/MyBetComponent/constant.js